import { createContext, useState, useContext } from "react";

const FiltersContext = createContext();

export const FiltersProvider = ({ children }) => {
  const [filters, setFilters] = useState({});

  // 🔹 Actualizar filtros de una página
  const updateFilters = (pageKey, newFilters) => {
    setFilters(prev => {
      const current = prev[pageKey];

      // Evita render innecesario
      if (JSON.stringify(current) === JSON.stringify(newFilters)) {
        return prev;
      }

      return {
        ...prev,
        [pageKey]: newFilters,
      };
    });
  };

  // 🔹 Obtener filtros (puede devolver undefined)
  const getFilters = (pageKey) => {
    return filters[pageKey];
  };

  // 🔹 Limpiar filtros de una página
  const clearFilters = (pageKey) => {
    setFilters(prev => {
      const newState = { ...prev };
      delete newState[pageKey];
      return newState;
    });
  };

  return (
    <FiltersContext.Provider
      value={{
        filters,
        updateFilters,
        getFilters,
        clearFilters,
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
};

export const useFilters = () => useContext(FiltersContext);